import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import TableHeader from './TableHeader'
import TableItem from './TableItem'
import { Spinner, Pagination } from 'controls'
import { utils } from 'services'
import style from './style'

class Table extends PureComponent {
  static propTypes = {
    onItemClick: PropTypes.func,
    onPageChange: PropTypes.func,
    loading: PropTypes.bool.isRequired
  }

  static defaultProps = {
    onItemClick: () => {},
    onPageChange: () => {},
    loading: false
  }

  constructor(props) {
    super(props)

    this.guid = utils.getGuid()
  }

  onPageChange(selected) {
    this.props.onPageChange(selected)
  }

  render() {
    const { fields, items, pageCount, currentPage, loading } = this.props

    return (
      <div style={{ width: '100%' }}>
        <TableHeader fields={fields} tableGuid={this.guid} />
        <div className="table-body">
          {loading && (
            <div className="loading-overlay">
              <Spinner size={40} />
            </div>
          )}
          {items.map((item, index) => (
            <TableItem
              onClick={this.props.onItemClick}
              key={index}
              item={item}
              fields={fields}
            />
          ))}
        </div>
        <Pagination
          pageCount={pageCount}
          currentPage={currentPage}
          onPageChange={this.onPageChange}
        />
        <style jsx>{style}</style>
      </div>
    )
  }
}

export default Table
